import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useDispatch } from "react-redux";
import {
  clearFilter,
  setFilterType,
} from "../../../redux/refundList/refundListSlice";

const RefundListHeader = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [refundType, setRefundType] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const dispatch = useDispatch();

  const handleRefundTypeChange = (e) => {
    const value = e.target.value;
    setRefundType(value);
    dispatch(setFilterType({ refundType: value }));
  };

  const handlePaymentTypeChange = (e) => {
    const value = e.target.value;
    setPaymentType(value);
    dispatch(setFilterType({ paymentType: value }));
  };

  const handleFilter = () => {
    const validRefundTypes = ["CashBack", "Treatment"];
    const validPaymentTypes = ["Cash", "Bank"];
    dispatch(
      setFilterType({
        startDate,
        endDate,
        refundType: validRefundTypes.includes(refundType) ? refundType : "",
        paymentType: validPaymentTypes.includes(paymentType) ? paymentType : "",
      }),
    );
  };

  const handleReset = () => {
    setStartDate("");
    setEndDate("");
    setRefundType("");
    setPaymentType("");
    dispatch(clearFilter());
  };

  return (
    <Box sx={{ p: 3, bgcolor: "background.paper", borderRadius: 2, mb: 3 }}>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ fontSize: "13px", color: "#444", mb: 0.5 }}>Start Date</Box>
          <TextField
            fullWidth
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            size="small"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ fontSize: "13px", color: "#444", mb: 0.5 }}>End Date</Box>
          <TextField
            fullWidth
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            size="small"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ fontSize: "13px", color: "#444", mb: 0.5 }}>Refund Type</Box>
          <FormControl fullWidth size="small">
            <Select
              value={refundType}
              onChange={handleRefundTypeChange}
              displayEmpty
            >
              <MenuItem value="">All Types</MenuItem>
              <MenuItem value="CashBack">CashBack</MenuItem>
              <MenuItem value="Treatment">Treatment</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ fontSize: "13px", color: "#444", mb: 0.5 }}>Payment Type</Box>
          <FormControl fullWidth size="small">
            <Select
              value={paymentType}
              onChange={handlePaymentTypeChange}
              displayEmpty
            >
              <MenuItem value="">All Types</MenuItem>
              <MenuItem value="Cash">Cash</MenuItem>
              <MenuItem value="Bank">Bank</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button variant="contained" onClick={handleFilter} size="small">
              Search
            </Button>
            <Button variant="outlined" onClick={handleReset} size="small">
              Reset
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RefundListHeader;